
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/sitemap",
      function () {
        return require("private-next-pages/articles/sitemap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/sitemap"])
      });
    }
  